import { FormattedMessage } from 'react-intl';
import { calcDuration } from 'src/utils/helpers/calcDuration';
import { formatDateShort } from 'src/utils/helpers/transformDate';

export const eventFormObjectionsMapper = (objections) => {
	return objections.map((obj) => {
		const formattedDate = formatDateShort(obj.createdAt);
		const duration = calcDuration(obj, 'createdAt');
		const style = {
			fontSize: '12px',
			color: '#8c8c8c',
			lineHeight: '1.66',
		};

		return {
			id: obj.id,
			typeId: obj.type?.id,
			comment: obj.comment,
			key: obj.id,
			label: obj.type.name,
			remark: [
				<span style={style} key={1}>
					{obj.comment}
				</span>,
				<br key={2} />,
				<span style={style} key={3}>
					{formattedDate} (
					<FormattedMessage
						id="CellRender.duration.days"
						values={{ count: duration }}
						defaultMessage="{count, plural, =0 {менее дня} one {# день} few {# дня} many {# дней} other {# дней}}"
					/>
					)
				</span>,
			],
		};
	});
};
